export default {
  app: {
    quiz: {
      nrOfCorrectAnswers: '정답: {state}',
    },
  },
};
